import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BreadcrumbsComponent } from './bread-crumbs.component';
import { AngularMaterialModule } from 'src/app/material.module';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [CommonModule, RouterModule,AngularMaterialModule,ReactiveFormsModule],
  exports: [BreadcrumbsComponent],
  declarations: [BreadcrumbsComponent]
})
export class BreadcrumbsModule {}
